/* SUDADEROTAS · Subir el ticket promedio dentro del personalizador.
   1) «Hazla para alguien más»: después de agregar, un clic agrega otra prenda con EL MISMO diseño en otra talla/corte
      (escalera de Shopify: 2 prendas = 10% + envío gratis; 3 o más = 20% + envío gratis; descuentos automáticos).
   2) «Producción prioritaria» (+$99) en el último paso, hasta el 11 de diciembre: producto aparte, una vez por pedido.
   3) Precio de comparación (tachado) junto a los precios del personalizador, con el ahorro en pesos («Ahorras $X»).
   4) Los datos técnicos (vistas y colores) se guardan como privados («_…»): el taller y el admin los ven, el cliente no en el pago.
   No toca el núcleo: lee lo que el personalizador manda a cart/add.js y reusa esos mismos datos. */
(function (root) {
"use strict";
if (root.SDR_MAS_VENTA) return; root.SDR_MAS_VENTA = true;
if (!/\/products\//.test(location.pathname)) return;
var PRIORIDAD = { variante: 67838586487093, precio: 99, hasta: Date.parse("2026-12-12T06:00:00Z") /* fin del 11 de diciembre, hora de CDMX */ };
/* se guardan con «_» para que no salgan en la pantalla de pago (siguen en el pedido y en el admin) */
var PRIVADOS = { "properties[Vista frente]": "properties[_Vista frente]", "properties[Vista espalda]": "properties[_Vista espalda]", "properties[Colores]": "properties[_Colores]" };
/* escalera por cantidad de prendas personalizadas (descuentos automáticos de Shopify) */
function descPara(n) { return n >= 3 ? 0.2 : n >= 2 ? 0.1 : 0; }
function textoOferta(n) { return n >= 3 ? "<b>20% de descuento</b> en todas + envío gratis" : n >= 2 ? "<b>10% de descuento</b> + envío gratis" : ""; }
var raiz = (root.Shopify && Shopify.routes && Shopify.routes.root) || "/";
var ultimo = null, vuelta = 0, producto = null, f0 = root.fetch;
function dinero(n) { return "$" + Math.round(n).toLocaleString("es-MX"); }
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
function carrito() { return f0.call(root, raiz + "cart.js").then(function (r) { return r.json(); }); }
function prod() {
if (producto) return Promise.resolve(producto);
return f0.call(root, location.pathname.replace(/\/$/, "") + ".js").then(function (r) { return r.json(); }).then(function (p) { producto = p; return p; });
}
var css = document.createElement("style");
css.textContent =
".sdr-prio{grid-column:1/-1;flex:1 1 100%;width:100%;box-sizing:border-box;display:flex;gap:12px;align-items:flex-start;margin:0 0 12px;padding:14px;border:2px solid var(--sdr-linea,#d5dcd9);border-radius:16px;background:#fff;cursor:pointer;text-align:left}" +
".sdr-prio:has(input:checked){border-color:var(--sdr-rojo,#c8102e);background:#fff6f6}" +
".sdr-prio input{width:22px;height:22px;margin:2px 0 0;accent-color:var(--sdr-rojo,#c8102e);flex:0 0 auto}" +
".sdr-prio b{display:block;font-size:16px}.sdr-prio small{display:block;font-size:14px;line-height:1.35;color:#5d6e67;margin-top:2px}.sdr-prio em{font-style:normal;color:var(--sdr-rojo,#c8102e);font-weight:800}" +
".sdr-otra{margin:14px 0 0;padding:16px;border-radius:16px;background:#fff;border:2px dashed var(--sdr-rojo,#c8102e);text-align:left}" +
".sdr-otra h4{margin:0;font-size:18px}.sdr-otra>p{margin:4px 0 10px;font-size:14px;color:#5d6e67}" +
".sdr-otra-fila{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px}" +
".sdr-otra-fila button{min-width:44px;min-height:40px;padding:6px 12px;border:2px solid var(--sdr-linea,#d5dcd9);border-radius:12px;background:#fff;font-weight:800;font-size:14px;cursor:pointer;color:#1d2f2a}" +
".sdr-otra-fila button[aria-pressed=true]{border-color:#1d2f2a;background:#1d2f2a;color:#fff}" +
".sdr-otra-fila button:disabled{opacity:.35;cursor:not-allowed;text-decoration:line-through}" +
".sdr-otra-ok{width:100%;min-height:50px;border:0;border-radius:14px;background:var(--sdr-rojo,#c8102e);color:#fff;font-weight:900;font-size:16px;cursor:pointer}.sdr-otra-ok:disabled{opacity:.5}" +
".sdr-otra-ok s{opacity:.75;font-weight:600;margin-left:6px}" +
".sdr-otra-msj{margin:8px 0 0!important;font-weight:700;color:#1f7a3e!important}.sdr-otra-nota{margin:8px 0 0!important;font-size:12.5px!important}";
document.head.appendChild(css);

/* ---------- lo que el personalizador manda al carrito ---------- */
function esDelPersonalizador(b) { return root.FormData && b instanceof FormData && b.has("properties[_config]"); }
function copiar(fd) { var c = []; fd.forEach(function (v, k) { c.push([PRIVADOS[k] || k, v]); }); return c; }
function armar(datos) { var fd = new FormData(); datos.forEach(function (kv) { if (kv[1] instanceof File) fd.append(kv[0], kv[1], kv[1].name); else fd.append(kv[0], kv[1]); }); return fd; }
var prioridadMarcada = false, agregandoPrioridad = null;
function asegurarPrioridad() {
if (!prioridadMarcada) return Promise.resolve();
if (agregandoPrioridad) return agregandoPrioridad;
agregandoPrioridad = carrito().then(function (c) {
if (c.items.some(function (i) { return i.variant_id === PRIORIDAD.variante; })) return;
return f0.call(root, raiz + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: PRIORIDAD.variante, quantity: 1 }] }) });
}).catch(function () {}).then(function () { agregandoPrioridad = null; pintarPrioridad(); });
return agregandoPrioridad;
}
root.fetch = function (u, o) {
var url = typeof u === "string" ? u : u && u.url || "";
if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && esDelPersonalizador(o.body)) {
var datos = copiar(o.body), o2 = Object.assign({}, o, { body: armar(datos) });
return root.SDR_MV_F.call(this, u, o2).then(function (r) {
if (!r.ok) return r;
ultimo = datos; vuelta++;
/* «Comprar ahora» redirige al pago en cuanto esto termina: la prioridad se agrega antes */
return asegurarPrioridad().then(function () { return r; });
});
}
return root.SDR_MV_F.apply(this, arguments);
};
root.SDR_MV_F = f0;

/* ---------- 2) Producción prioritaria ---------- */
var cajaPrio = null, yaEnCarrito = false;
function pintarPrioridad() {
if (!cajaPrio) return;
carrito().then(function (c) {
yaEnCarrito = c.items.some(function (i) { return i.variant_id === PRIORIDAD.variante; });
var inp = cajaPrio.querySelector("input"), t = cajaPrio.querySelector("[data-t]");
if (yaEnCarrito) { inp.checked = true; inp.disabled = true; t.innerHTML = "Ya está en tu carrito: todo tu pedido se produce primero."; }
}).catch(function () {});
}
function ponerPrioridad() {
if (Date.now() > PRIORIDAD.hasta) { prioridadMarcada = false; return; }
var compra = document.querySelector(".sdr [data-sdr-compra]");
if (!compra || compra.querySelector(".sdr-prio")) return;
cajaPrio = document.createElement("label"); cajaPrio.className = "sdr-prio";
cajaPrio.innerHTML = '<input type="checkbox" name="sdr-prioridad"><span><b>⚡ Producción prioritaria <em>+' + dinero(PRIORIDAD.precio) + '</em></b><small data-t>Tu pedido pasa al frente de la fila de producción. Disponible hasta el 11 de diciembre.</small></span>';
cajaPrio.querySelector("input").addEventListener("change", function (e) { prioridadMarcada = e.target.checked; });
compra.insertBefore(cajaPrio, compra.firstChild);
pintarPrioridad();
}

/* ---------- 1) Hazla para alguien más ---------- */
function opciones(p) { var n = p.options.map(function (o) { return typeof o === "string" ? o : o.name; }); return { prenda: n.indexOf("Prenda"), corte: n.indexOf("Corte"), talla: n.indexOf("Talla") }; }
function op(v, i) { return i < 0 ? null : v.options[i]; }
function ponerOtra() {
var listo = document.querySelector(".sdr [data-sdr-listo]");
if (!listo || listo.hidden || !ultimo) return;
var clave = String(ultimo.length) + idDe(ultimo) + "#" + vuelta;
if (listo.dataset.sdrOtra === clave) return;
listo.dataset.sdrOtra = clave;
var vieja = listo.querySelector(".sdr-otra"); if (vieja) vieja.remove();
Promise.all([prod(), carrito()]).then(function (r) {
var p = r[0], c = r[1], I = opciones(p), base = p.variants.filter(function (v) { return v.id === +idDe(ultimo); })[0];
if (!base || I.talla < 0) return;
var prenda = op(base, I.prenda), corte = op(base, I.corte), talla = null;
var mios = c.items.filter(function (i) { return i.product_id === p.id; }).reduce(function (s, i) { return s + i.quantity; }, 0);
var V = p.variants.filter(function (v) { return op(v, I.prenda) === prenda; });
var cortes = I.corte < 0 ? [] : V.map(function (v) { return op(v, I.corte); }).filter(function (x, k, a) { return a.indexOf(x) === k; });
if (cortes.length < 2 && V.every(function (v) { return op(v, I.talla) === op(base, I.talla); })) return; /* unitalla: no hay otra opción que ofrecer */
var box = document.createElement("div"); box.className = "sdr-otra";
box.innerHTML = "<h4>¿Hazla para alguien más?</h4><p>" + mensaje() + "</p>" +
(cortes.length > 1 ? '<div class="sdr-otra-fila" data-cortes></div>' : "") + '<div class="sdr-otra-fila" data-tallas></div>' +
'<button type="button" class="sdr-otra-ok" disabled>Elige una talla</button><p class="sdr-otra-msj" hidden></p>' +
'<p class="sdr-otra-nota">¿Lleva otro nombre o foto? Mejor usa «Personalizar otra».</p>';
listo.appendChild(box);
var ok = box.querySelector(".sdr-otra-ok"), msj = box.querySelector(".sdr-otra-msj");
/* lo que gana el cliente si agrega una prenda más (mios = prendas que ya tiene en el carrito) */
function mensaje() { var t = textoOferta(mios + 1); return "El mismo diseño en otra talla, con un clic." + (t ? " Con " + (mios + 1) + " prendas: " + t + "." : ""); }
function elegida() { return V.filter(function (v) { return (I.corte < 0 || op(v, I.corte) === corte) && op(v, I.talla) === talla; })[0]; }
function boton() {
var v = elegida();
if (!v) { ok.disabled = true; ok.textContent = "Elige una talla"; return; }
ok.disabled = !v.available;
var pr = v.price / 100, d = descPara(mios + 1);
ok.textContent = "Agregar talla " + talla + " · " + dinero(pr * (1 - d)) + (d ? " (−" + Math.round(d * 100) + "%)" : "");
}
function tallas() {
var fila = box.querySelector("[data-tallas]"); fila.innerHTML = "";
V.filter(function (v) { return I.corte < 0 || op(v, I.corte) === corte; }).forEach(function (v) {
var b = document.createElement("button"); b.type = "button"; b.textContent = op(v, I.talla); b.disabled = !v.available;
b.setAttribute("aria-pressed", op(v, I.talla) === talla);
b.addEventListener("click", function () { talla = op(v, I.talla); fila.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); boton(); });
fila.appendChild(b);
});
if (!elegida()) talla = null; boton();
}
if (cortes.length > 1) {
var fc = box.querySelector("[data-cortes]");
cortes.forEach(function (ct) {
var b = document.createElement("button"); b.type = "button"; b.textContent = ct; b.setAttribute("aria-pressed", ct === corte);
b.addEventListener("click", function () { corte = ct; fc.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); tallas(); });
fc.appendChild(b);
});
}
tallas();
ok.addEventListener("click", function () {
var v = elegida(); if (!v) return;
var fd = new FormData();
ultimo.forEach(function (kv) {
if (kv[1] instanceof File) { fd.append(kv[0], kv[1], kv[1].name); return; }
var k = kv[0], val = kv[1];
if (k === "id") val = v.id; else if (k === "quantity") val = 1;
else if (k === "properties[_config]") { try { var j = JSON.parse(val); j.cantidad = 1; if ("talla" in j) j.talla = talla; if ("corte" in j) j.corte = corte; j.copiaDe = "hazla-para-alguien-mas"; val = JSON.stringify(j); } catch (e) {} }
fd.append(k, val);
});
ok.disabled = true; ok.textContent = "Agregando…";
f0.call(root, raiz + "cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } }).then(function (r) {
if (!r.ok) throw new Error();
document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
msj.hidden = false; msj.textContent = "¡Agregada! " + (corte ? corte + " · " : "") + "talla " + talla + " ya está en tu carrito.";
mios++;
box.querySelector("p").innerHTML = "¿Otra más? " + mensaje();
boton();
}).catch(function () { msj.hidden = false; msj.style.color = "#c8102e"; msj.textContent = "No se pudo agregar. Inténtalo de nuevo."; boton(); });
});
}).catch(function () {});
}
function idDe(d) { var x = d.filter(function (kv) { return kv[0] === "id"; })[0]; return x ? String(x[1]) : ""; }

/* ---------- 3) Precio de comparación ---------- */
var css2 = document.createElement("style");
css2.textContent = ".sdr .sdr-antes{margin-left:6px;color:#8a958f;text-decoration:line-through;font-weight:600;font-size:.82em;white-space:nowrap}" +
".sdr .sdr-off{display:inline-block;margin-left:8px;padding:2px 8px;border-radius:999px;background:var(--sdr-rojo,#c8102e);color:#fff;font-size:.55em;font-weight:900;vertical-align:middle;letter-spacing:.02em;white-space:nowrap}" +
".sdr [data-sdr-precio] .sdr-off{display:table;margin:4px 0 0 auto;font-size:13px}";
document.head.appendChild(css2);
/* conAhorro: además del tachado, la etiqueta «Ahorras $X» (en pesos, no en %: se ve parejo en todas las prendas) */
function tachar(el, antes, ahora, conAhorro) {
if (!el) return;
var s = el.querySelector(".sdr-antes"), o = el.querySelector(".sdr-off"), ok = antes && ahora && antes > ahora;
if (!ok) { if (s) s.remove(); if (o) o.remove(); return; }
var t = dinero(antes / 100);
if (!s) { s = document.createElement("s"); s.className = "sdr-antes"; el.appendChild(s); }
if (s.textContent !== t) s.textContent = t;
if (conAhorro) {
var pt = "Ahorras " + dinero((antes - ahora) / 100);
if (!o) { o = document.createElement("span"); o.className = "sdr-off"; el.appendChild(o); }
if (o.textContent !== pt) o.textContent = pt;
} else if (o) o.remove();
}
function deLaPrenda(nombre) {
if (!producto) return [];
var I = opciones(producto);
return producto.variants.filter(function (v) { return String(op(v, I.prenda)).trim().toLowerCase() === String(nombre || "").trim().toLowerCase(); });
}
function minimo(vs) { var m = null; vs.forEach(function (v) { if (!m || v.price < m.price || (v.price === m.price && v.compare_at_price > m.compare_at_price)) m = v; }); return m; }
function precios() {
if (!producto) return;
var tarjeta = null;
document.querySelectorAll(".sdr .sdr-prenda").forEach(function (b) {
var nb = b.querySelector("b"), vs = deLaPrenda(nb && nb.textContent), m = minimo(vs);
tachar(b.querySelector("small"), m && m.compare_at_price, m && m.price, false);
if (b.getAttribute("aria-checked") === "true") tarjeta = m;
});
var sel = document.querySelector(".sdr .sdr-talla[aria-checked='true']"), v = null;
if (sel) v = producto.variants.filter(function (x) { return x.id === +sel.dataset.id; })[0];
var pe = document.querySelector(".sdr [data-sdr-precio]"), vp = v;
if (!vp && pe) {
/* sin talla elegida el precio mostrado puede ser el más bajo de la tienda: usamos la variante que tiene ese precio */
var txt = (pe.firstChild && pe.firstChild.nodeType === 3 ? pe.firstChild.nodeValue : pe.textContent) || "", cent = Math.round(parseFloat(txt.replace(/[^0-9.]/g, "")) * 100);
var cand = (tarjeta ? deLaPrenda(op(tarjeta, opciones(producto).prenda)) : []).filter(function (x) { return x.price === cent; });
if (!cand.length) cand = producto.variants.filter(function (x) { return x.price === cent; });
vp = cand.filter(function (x) { return x.compare_at_price > x.price; })[0] || null;
}
tachar(pe, vp && vp.compare_at_price, vp && vp.price, true);
var dd = document.querySelector(".sdr .sdr-total dd"), n = +((document.querySelector(".sdr [data-sdr-cant]") || {}).textContent || 1) || 1;
tachar(dd, v && v.compare_at_price * n, v && v.price * n, false);
}
prod().then(precios).catch(function () {});

function revisar() { ponerPrioridad(); ponerOtra(); precios(); }
new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["hidden", "aria-checked"] });
if (document.readyState !== "loading") revisar(); else document.addEventListener("DOMContentLoaded", revisar);
})(this);
